module.exports = __webpack_public_path__ + "static/media/phase_scr.cfdf9bfe.png";